module.exports = __webpack_public_path__ + "img/icon_seller.29979e23.svg";